import React, { useEffect, useRef, useState } from "react";
import { RxSpeakerOff } from "react-icons/rx";

import { RxSpeakerLoud } from "react-icons/rx";

const Banner = () => {
  let videoRef = useRef(null);
  let [state, setState] = useState(true);

  useEffect(() => {
    videoRef.current.play();
  }, []);

  const handleMute = () => {
    setState(!state);
  };

  return (
    <div className="relative">
      <div
        onClick={handleMute}
        className="absolute  text-white top-4 left-4 z-10 cursor-pointer">
        {!state ? (
          <RxSpeakerLoud className="text-4xl max-sm:text-xl" />
        ) : (
          <RxSpeakerOff className="text-4xl max-sm:text-xl" />
        )}
      </div>
      <video
        ref={videoRef}
        controls
        loop
        autoplay
        muted={state}
        playsInline
        className="w-full  brightness-[80%] ">
        <source src="https://res.cloudinary.com/dvyrx4kg8/video/upload/v1748271155/a1rxa6jw3hle8nribnxe.mp4" />
      </video>
    </div>
  );
};

export default Banner;
